import { flattenDimensions, setDefaultValues, setToTopDimIds } from '../dimensionUtils'
import { isAddable } from './index.js'

export function createDefaultPivotConfig(dimensions) {
  let chart = 'pie-chart'
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas

  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = type === 'time' ? 'columns' /*: type === 'location' ? 'rows'*/ : 'filters'
      if (type === 'time') {
        role = 'filters'
      }
      return {
        id: key,
        role: role,
      }
    }),
  }

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  // let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  // if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
  //   let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  //   // repensar seguro...
  //   let xCandidate = filterDims.find(d => metas[d.id].type !== 'time') || filterDims[0]
  //   xCandidate.role = 'rows'
  //   rowsDim.role = 'filters'
  //   // if (filterDims.length > 0) {
  //   //   filterDims = filterDims.slice(0, 2)
  //   //   filterDims.forEach(d => (d.role = 'rows'))
  //   //   rowsDim.role = 'filters'
  //   // } else {
  //   //   let colsDim = pivotConfig.dimensions.find(d => d.role === 'columns')
  //   //   rowsDim.role = 'columns'
  //   //   colsDim.role = 'rows'
  //   // }
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // }

  //RELLENAMOS ROWS Y COLS
  //Seleccionamos la primera extraDim con mas de un valor
  let extraDims = Object.values(dimensions.dimensionMetas).filter(
    d => d.type !== 'time' && d.type !== 'location'
  )

  // let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')

  let filtersExtraDims = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  )

  let locDim = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && metas[d.id].type === 'location'
  )

  let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')

  let toRows

  if (rowsDims.length === 0 && filtersExtraDims.length > 0) {
    toRows = filtersExtraDims.slice(0, 1)
    toRows.forEach(d => (d.role = 'rows'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  } else if (rowsDims.length === 0 && filtersExtraDims.length === 0 && locDim.length !== 0) {
    toRows = locDim.slice(0, 1)
    toRows.forEach(d => (d.role = 'rows'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }
  // let count = 0
  // while (
  //   count < filtersExtraDims.length &&
  //   rowsDims.length === 1 &&
  //   rowsDims[0].values.length === 1
  // ) {
  //   // if (colsDims.length === 1 && colsDims[0].values.length === 1) {
  //   rowsDims[0].role = 'filters'
  //   toRows = filtersExtraDims.slice(0, 1) // [filtersExtraDims[0]]
  //   toRows.forEach(d => (d.role = 'rows'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  //   // }
  //   filtersExtraDims = pivotConfig.dimensions.filter(
  //     d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  //   )
  //   rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  //   count++
  // }

  setToTopDimIds(pivotConfig, metas)

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  return pivotConfig
}

export function getAvailability(dimensions, dataCard) {
  // let unit = dataCard.data[0].unit
  let hasExtraDims =
    Object.values(dimensions.dimensionMetas).filter(d => d.type !== 'time' && d.type !== 'location')
      .length > 0
  let locDim = Object.keys(dimensions.dimensionOptions).find(
    key => dimensions.dimensionMetas[key]?.type === 'location'
  )
  let dimOptions = flattenDimensions(dimensions).dimensionOptions
  let locOptions = locDim && dimOptions[locDim]
  let onlyOneLocation = locDim && locOptions.length <= 1
  // let available = isAddable(unit) && noTimeDims.length > 1
  // return { enabled: available, enableable: available }
  let unit = dataCard.data[0].unit
  let available = isAddable(unit) && (hasExtraDims || !onlyOneLocation)
  console.log("IsAddable: " + isAddable(unit));
  console.log("hasExtraDims: " + hasExtraDims);
  console.log("onlyOneLocation: " + onlyOneLocation);
  return { enabled: available, enableable: available }
  //return { enabled: true, enableable: true }
}

export default {
  getAvailability,
  createDefaultPivotConfig,
  maxChartDims: 1,
  maxRowDims: 1,
  sdvComponent: 'DonutChart',
  forceSngleTypes: true,
}
